export const Columns = () => [
  {
    id: 'stt',
    numeric: false,
    disablePadding: false,
    label: 'STT',
    width: '100px',
    align: 'center',
  },
  {
    id: 'employeeName',
    numeric: false,
    disablePadding: false,
    label: 'Tên nhân viên',
    align: 'center',
  },
  {
    id: 'departmentName',
    numeric: true,
    align: 'center',
    disablePadding: false,
    label: 'Bộ phận',
  },
  {
    id: 'totalTasks',
    numeric: true,
    align: 'center',
    disablePadding: false,
    label: 'Tổng số C.Việc',
  },
  {
    id: 'completedTasks',
    numeric: true,
    align: 'center',
    disablePadding: false,
    label: 'C.Việc hoàn thành',
  },
  {
    id: 'inProgressTasks',
    numeric: true,
    align: 'center',
    disablePadding: false,
    label: 'C.Việc đang làm',
  },
  {
    id: 'pendingReviewTasks',
    numeric: true,
    align: 'center',
    disablePadding: false,
    label: 'C.Việc chờ đánh giá',
  },
  {
    id: 'planningTasks',
    numeric: true,
    align: 'center',
    disablePadding: false,
    label: 'C.Việc kế hoạch',
  },
  {
    id: 'incompleteTasks',
    numeric: true,
    align: 'center',
    disablePadding: false,
    label: 'C.Việc không hoàn thành',
  },
  {
    id: 'overdueTask',
    numeric: true,
    align: 'center',
    disablePadding: false,
    label: 'C.Việc trễ hạn',
  },
  {
    id: 'completionRate',
    numeric: true,
    align: 'center',
    disablePadding: false,
    label: 'Tỷ lệ hoàn thành %',
  },
];
